module.exports = __webpack_public_path__ + "55896de98f713c99b75547802b022ef5.fbx";